import api from "app/api";
import { Options } from "common";

export interface RedflagPartnerItem {
  id: number;
  name: string;
  reason?: string;
}

export type RedflagPartnerOptions = Options;

export function getRedflagPartnerService(scope?: any) {
  return api.getService<
    RedflagPartnerItem,
    RedflagPartnerItem,
    RedflagPartnerOptions
  >("redflag-partners", {
    scope,
    //params goes here
  });
}
